interface CategoryStats {
  category: string;
  amount: number;
  percentage: number;
}

export const getTopCategories = (transactions: any[]): CategoryStats[] => {
  // Group transactions by category
  const categoryTotals = new Map<string, number>();
  let totalSpending = 0;

  transactions.forEach(transaction => {
    if (transaction.amount < 0) { // Only count spending
      const amount = Math.abs(transaction.amount);
      const category = transaction.category || 'Uncategorized';
      categoryTotals.set(
        category, 
        (categoryTotals.get(category) || 0) + amount
      );
      totalSpending += amount;
    }
  });

  // Convert to array and sort by amount
  const categories = Array.from(categoryTotals.entries())
    .map(([category, amount]) => ({
      category,
      amount,
      percentage: (amount / totalSpending) * 100
    }))
    .sort((a, b) => b.amount - a.amount)
    .slice(0, 5); // Get top 5

  return categories;
};
